<app-esqueleto-tableros>
	<div titulo class="encabezadosSeparacion"
		[matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
		[appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
		<span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
		<span class="bullSeparation">&bull;</span>
		<span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
	</div>

	<div contenido class="contenidoClass">

		<div class="contenidoTablero">
			<div class="contenidoEncabezado">
				<div class="encabezado2 titulo-contenidomenu">
					{{'gestion.formulacion.matrizFoda.factoresInternos'|translate}}
				</div>
				<div class="iconosE">
					<mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
					[matMenuTriggerFor]="menu2">more_vert</mat-icon>
					<mat-menu #menu2="matMenu">
						<button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
							<mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
							<span> {{'gestion.formulacion.matrizFoda.export'|translate}}</span>
						</button>
					</mat-menu>
				</div>
			</div>

			<div class="zonaTablas">
				@if (viewTablero) {
					@for(inter of diccionarioFLOA1; track inter; let i = $index){
						<app-contenedor-elementos class="tabla" [header]="{title: inter.internosss.elementoi }">
							<div body class="w3-scroll tab">
								<table class="tabla-aleema">
									<thead>
										<tr>
											<th style="width: 4vw;"> # </th>
											<th>
												{{inter.internosss.elementoi}}</th>
											<th *appRoles="permisos.ADMINISTRACION" style="width: 4vw;">
												<mat-icon matTooltip="{{'gestion.formulacion.matrizFoda.agregarElem'|translate}}"
													class="iconoMen colorBotonDeNuevo" (click)="abrirFormAgregar(inter.internosss,elemento)">
													add_circle_outline
												</mat-icon>
											</th>
										</tr>
									</thead>
									<tbody>
										@for(ele of inter.elementooo; track ele; let i = $index){
											@if (mostrarElem(inter.internosss.tipoe, ele)) {
												<tr>
													<td>
														{{obtCodigo(inter.internosss)}}{{i+1}}</td>
													<td style="max-width: 20vw; overflow: hidden;" [matTooltip]="ele.nombre" [appOverflowTooltip]="ele.nombre">
														{{ele.nombre}}
													</td>
													<td *appRoles="permisos.ADMINISTRACION">
														<mat-icon class="iconoMen"
															matTooltip="{{'gestion.formulacion.matrizFoda.tooltip1'|translate}}"
															(click)="abrirFormEdit(ele,inter.internosss)">edit</mat-icon>
														<mat-icon class="iconoMen"
															matTooltip="{{'gestion.formulacion.matrizFoda.tooltip2'|translate}}"
															(click)="alertas('eliminar',ele)">delete</mat-icon>
													</td>
												</tr>
											}
										}
									</tbody>
								</table>
							</div>
						</app-contenedor-elementos>
					}
				}@else {
					<div class="w3-half_e" style="height: 33vh;">
						<div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
							<app-skeleton-table [columnas]="3" [filas]="6" />
						</div>
					</div>
					<div class="w3-half_e" style="height: 33vh;">
						<div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
							<app-skeleton-table [columnas]="3" [filas]="6" />
						</div>
					</div>
				}
			</div>

			<div class="encabezado2 titulo-contenidomenu">
				{{'gestion.formulacion.matrizFoda.factoresExternos'| translate}}
			</div>

			<div class="zonaTablas">
				@if (viewTablero) {
					@for(exter of diccionarioFLOA2; track exter;){
						<app-contenedor-elementos class="tabla" [header]="{title: exter.externosss.elementoe }">
							<div body class="w3-scroll tab">
								<table class="tabla-aleema">
									<thead>
										<tr>
											<th style="width: 4vw;"> # </th>
											<th>
												{{exter.externosss.elementoe}}</th>
											<th *appRoles="permisos.ADMINISTRACION" style="width: 4vw;">
													<mat-icon matTooltip="{{'gestion.formulacion.matrizFoda.agregarElem'|translate}}"
													(click)="abrirFormAgregar(exter.externosss,elemento)"
													class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon>
											</th>
										</tr>
									</thead>
									<tbody>
										@for(ele of exter.elementooo; track ele; let i = $index){
											@if(mostrarElem(exter.externosss.tipoe, ele)){
												<tr>
													<td>
														{{obtCodigo(exter.externosss)}}{{i+1}} </td>
													<td style="max-width: 20vw; overflow: hidden;" [matTooltip]="ele.nombre" [appOverflowTooltip]="ele.nombre">
														{{ele.nombre}}
													</td>
													<td *appRoles="permisos.ADMINISTRACION">
														<mat-icon class="iconoMen" matTooltip="{{'gestion.formulacion.matrizFoda.tooltip1'|translate}}"
															(click)="abrirFormEdit(ele,exter.externosss)">edit</mat-icon>
														<mat-icon class="iconoMen" matTooltip="{{'gestion.formulacion.matrizFoda.tooltip2'|translate}}"
															(click)="alertas('eliminar',ele)">delete</mat-icon>
													</td>
												</tr>
											}
										}
									</tbody>
								</table>
							</div>
						</app-contenedor-elementos>
					}
				}@else {
					<div class="w3-half_e" style="height: 33vh;">
						<div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
							<app-skeleton-table [columnas]="3" [filas]="6" />
						</div>
					</div>
					<div class="w3-half_e" style="height: 33vh;">
						<div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
							<app-skeleton-table [columnas]="3" [filas]="6" />
						</div>
					</div>
				}
			</div>
		</div>
	</div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" [cerrar]="false" (close)="cerrarForm()">
	<div modal-header>
		{{'gestion.formulacion.matrizFoda.agregarElem'|translate}}
	</div>

	<div modal-body>
		<form [formGroup]="formGeneral" style="padding-right: 1.5vw;">
			@if(formGeneral.hasError('isValid')){
			<mat-error class="error-message" style="margin-left: 10%; color: red;">
				{{'gestion.formulacion.matrizFoda.formText2'|translate}} <strong>
					{{'gestion.formulacion.matrizFoda.formText1'|translate}}.</strong>
			</mat-error>
			}
			<div class="form-group">
				<label for="nombre" class="form-label">
					{{'gestion.formulacion.matrizFoda.formText2' | translate}} *
				</label>
				<input id="nombre" formControlName="inputName" type="text" class="form-input anchosInputs"
				[matTooltip]="formGeneral.controls.inputName.value" [appOverflowTooltip]="formGeneral.controls.inputName.value"
					placeholder="{{'gestion.formulacion.matrizFoda.placeHolderNombre'|translate}}" required>
			</div>

			<div class="form-group">
				<label for="perspectiva" class="form-label">
					{{'gestion.formulacion.matrizFoda.formText6' | translate}} *
				</label>
				<select name="perspectiva" id="perspectiva" class="contentSelect anchosInputs"
					formControlName="inputPerspective" required>
					<option value="default" disabled selected>
						{{'gestion.formulacion.matrizFoda.formText7' | translate}}
					</option>
					@for (pers of perspectiva; track $index) {
						<option value="{{pers.id}}"
						[matTooltip]="pers.nombre" [appOverflowTooltip]="pers.nombre"> {{pers.nombre}} </option>
					}
				</select>
			</div>
		</form>
	</div>

	<app-button modal-footer
		[color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
		[text]="'menu.cancel' | translate"
		(clickB)="cerrarForm()"
	/>
	<app-button modal-footer
		[ngClass]="puede_guardar()"
		[color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
		[text]="'menu.Guardar' | translate"
		(clickB)="alertas('guardar')"
	/>
</app-modal>

<app-modal [isOpen]="modal2" [cerrar]="false" (close)="cerrarForm()">
	<div modal-header>
		{{'gestion.formulacion.matrizFoda.tooltip1'|translate}}"
	</div>

	<div modal-body>
		<form [formGroup]="formGeneral" style="padding-right: 1.5vw;">
			@if(formGeneral.hasError('isValid')){
			<mat-error class="error-message" style="margin-left: 10%; color: red;">
				{{'gestion.formulacion.matrizFoda.formText2'|translate}} <strong>
					{{'gestion.formulacion.matrizFoda.formText1'|translate}}.</strong>
			</mat-error>
			}
			<div class="form-group">
				<label for="nombreedit" class="form-label">
					{{'gestion.formulacion.matrizFoda.formText2' | translate}} *
				</label>
				<input id="nombreedit" formControlName="inputNameEdit" type="text" class="form-input anchosInputs"
				[matTooltip]="formGeneral.controls.inputNameEdit.value" [appOverflowTooltip]="formGeneral.controls.inputNameEdit.value"
					placeholder="{{'gestion.formulacion.matrizFoda.placeHolderNombre'|translate}}" required>
			</div>

			<div class="form-group">
				<label for="perspectiva" class="form-label">
					{{'gestion.formulacion.matrizFoda.formText6' | translate}} *
				</label>
				<select name="perspectiva" id="perspectiva" class="contentSelect anchosInputs"
					formControlName="inputPerspectiveEdit" required>
					<option value="default" disabled selected>
						{{'gestion.formulacion.matrizFoda.formText7' | translate}}
					</option>
					@for (pers of perspectiva; track $index) {
						<option value="{{pers.id}}"
						[matTooltip]="pers.nombre" [appOverflowTooltip]="pers.nombre"> {{pers.nombre}} </option>
					}
				</select>
			</div>
		</form>
	</div>

	<app-button modal-footer
		[color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
		[text]="'menu.cancel' | translate"
		(clickB)="cerrarForm()"
	/>
	<app-button modal-footer
		[ngClass]="puede_guardarEdit()"
		[color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
		[text]="'menu.Guardar' | translate"
		(clickB)="alertas('editar')"
	/>
</app-modal>